import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import BaseModal from "react-overlays/es/Modal";
import SettingsPanel from "./SettingsPanel";
import { modal, modalDialogWrapper, modalDialog, modalBackdrop } from "./classNames";
export var renderBackdrop = function renderBackdrop(props) {
  return React.createElement("div", _extends({}, props, {
    className: modalBackdrop
  }));
};

var SettingsModal = function SettingsModal(_ref) {
  var show = _ref.show,
      onHide = _ref.onHide,
      rest = _objectWithoutProperties(_ref, ["show", "onHide"]);

  var onWrapperClick = useCallback(function (event) {
    if (event.target === event.currentTarget) {
      onHide();
    }
  });
  return React.createElement(BaseModal, {
    className: modal,
    renderBackdrop: renderBackdrop,
    show: show,
    onHide: onHide
  }, React.createElement("div", {
    className: modalDialogWrapper,
    onClick: onWrapperClick,
    role: "button",
    tabIndex: 0
  }, React.createElement("div", {
    className: modalDialog
  }, React.createElement(SettingsPanel, _extends({}, rest, {
    handleClose: onHide
  })))));
};

SettingsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired
};
export default SettingsModal;